var _a;
import { procedureApplicabilitySlice } from './procedureApplicabilitySlice';
import { useSelector } from 'react-redux';
export var procedureApplicabilityReducers = (_a = {},
    _a[procedureApplicabilitySlice.name] = procedureApplicabilitySlice.reducer,
    _a);
export var useProcedureApplicabilitySelector = useSelector;
